/**
 * SAVED DASHBOARD VIEWS — QA-07.
 *
 * A view is a name and the screen's own filter query string. The encoding is
 * `state/filter-url.ts` and nothing here parses it: the server stores the string
 * opaquely and the screen hands it straight back to `decode`, so there is
 * exactly one filter vocabulary and no second copy to go stale.
 */
import axios from 'axios';
import { apiRoute } from '../constants/api-constants';

export interface SavedView {
  id: string;
  name: string;
  /** The filter query string, WITHOUT a leading '?'. */
  search: string;
  is_shared: boolean;
  /** Whether the signed-in reader may change or delete it. Decided by the
   *  server so the ownership rule lives in one place. */
  is_mine: boolean;
  created_at: string;
  updated_at: string;
}

export const listViews = async (): Promise<SavedView[]> => {
  const { data } = await axios.get<SavedView[]>(`${apiRoute}/dashboard/views`);

  return data || [];
};

/**
 * Create, or overwrite one of MY OWN by the same name.
 *
 * "Save" on this screen means "remember what is on screen as X"; if X is already
 * mine the reader means update it. Somebody else's shared view of the same name
 * is untouched — the server's uniqueness is per author.
 */
export const saveView = async (input: {
  name: string;
  search: string;
  is_shared?: boolean;
}): Promise<SavedView> => {
  const { data } = await axios.post<SavedView>(`${apiRoute}/dashboard/views`, input);

  return data;
};

export const deleteView = async (id: string): Promise<void> => {
  await axios.delete(`${apiRoute}/dashboard/views/${id}`);
};
